jQuery( document ).ready( function( $ ) {
  //declare strict mode
  'use strict';

  asscript.stickyNav = {
    setScrollHandler: function() {
      $( window ).on( 'scroll', asscript.stickyNav.adjustNav );
      return;
    },
    adjustNav: function() {
      var scrollHeight = $( window )[0].pageYOffset;
      var offsetTop = $( 'nav' )[0].offsetTop;
      var headerHeight = $( 'header' )[0].offsetTop + $( 'header' )[0].clientHeight;
      var innerHeight = $( window )[0].innerHeight;
      var innerWidth = $( window )[0].innerWidth;

      if( innerWidth < 1280 ) {
        if( $( 'nav' ).hasClass( 'sticky' ) ) {
          $( 'nav' ).removeClass( 'sticky' );
          return;
        }
      } else if( innerWidth >= 1280 ) {
        if( scrollHeight > offsetTop && !$( 'nav' ).hasClass( 'sticky' ) ) {
          $( 'nav' ).addClass( 'sticky' );
          return;
        } else if( scrollHeight < headerHeight ) {
          if( $( 'nav' ).hasClass( 'sticky' ) ) {
            $( 'nav' ).removeClass( 'sticky' );
            return;
          } else {
            return;
          }
        }
      }
    }
  };
  asscript.stickyNav.setScrollHandler();
} );
